export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "请在此输入您的文字",
      conversationalPlaceholder: "请在此输入您的回答",
      conversationClosed: "对话已关闭。",
      conversationalDisclaimer: "后续问题将根据您的回答由AI生成。"
    },
    openText: {
      openEndPlaceholder: "请在此输入您的文字"
    },
    multiText: {
      fieldPlaceholder: '答案 {number}',
      instruction: '请在下方至少输入 {count} 个答案，每个文本框一个',
      instructionWithoutMinimum: '请在下方输入您的答案，每个文本框一个',
      minimumEntries: '请至少输入 {count} 个答案后再继续。',
      unaidedBrandAwareness: {
        fieldPlaceholder: '品牌 {number}',
        minimumEntries: '请至少输入 {count} 个品牌后再继续。'
      }
    },
    multiselect: {
      caption: "请选择所有适用项"
    },
    rankOrder: {
      enterRankOrder: "输入排序顺序",
      placeholder: "将您的选择拖动到此处进行排序"
    },
    openNumeric: {
      label: "开放式数字"
    },
    complete: {
      message: "感谢您完成此调查。"
    },
    openVideo: {
      warning: "请在继续之前录制视频。",
      uploadStatusUploading: "请稍候，我们正在处理您的视频，完成后即可继续...",
      uploadStatusSuccess: "上传成功，您可以继续。",
      uploadStatusError: "上传未完成，请重试。"
    }
  },
  errors: {
    node: {
      text_invalid_email: '请输入有效的电子邮件地址',
      text_invalid_phone: '请输入有效的电话号码',
      text_invalid_us_zip: '请输入有效的美国邮政编码（ZIP）',
      text_invalid_ca_postal: '请输入有效的加拿大邮政编码',
      text_invalid_uk_postal: '请输入有效的英国邮政编码',
      text_invalid_custom: '请输入有效的{fieldName}',
      text_min_chars: '请至少输入 {min} 个字符',
      text_max_chars: '请输入不超过 {max} 个字符',
      text_alpha_not_allowed: '仅允许数字',
      text_numeric_not_allowed: '仅允许字母'
    },
    external: {
      invalid: '此问题的回答无效。',
      required: '必须回答此问题。',
      singlechoice_required: '请选择一个选项后再继续。',
      numeric_required: '请选择一个评分后再继续。',
      text_required: '请输入一个回答后再继续。',
      bigtext_required: '请输入一个回答后再继续。',
      singlechoiceother_incomplete: '请输入一个回答后再继续。',
      multiselectother_incomplete: '请输入一个回答后再继续。',
      numeric_invalid: '请输入有效的数字后再继续。',
      radiogrid_required: '请为每行选择一个选项后再继续。',
      incomplete: '请在完整回答此问题后继续。',
      multiselect_min: '请至少选择 {value} 个选项后再继续。',
      multiselect_max: '请最多选择 {value} 个选项后再继续。',
      multiselectother_min: '请至少选择 {value} 个选项后再继续。',
      multiselectother_max: '请最多选择 {value} 个选项后再继续。',
      multiselectgrid_min: '请至少为每行选择 {value} 个选项后再继续。',
      multiselectgrid_max: '请最多为每行选择 {value} 个选项后再继续。',
      rankorder_min: '请至少对 {value} 个项目进行排序后再继续。',
      rankorder_max: '请最多为 {value} 个项目进行排序后再继续。'
    }
  }
}
